import { api } from "@/lib/api-client";

export interface AgentKeyDto {
  id: string;
  keyPrefix: string;
  status: "active" | "revoked";
  lastUsedAt: string | null;
  createdAt: string;
}

export interface AgentSummary {
  id: string;
  name: string;
  status: "active" | "disabled";
  agentVersion: string | null;
  lastHeartbeatAt: string | null;
  lastStats: unknown | null;
  batchesToday: number;
  createdAt: string;
  keys: AgentKeyDto[];
}

export interface GeneratedKey {
  id: string;
  keyPrefix: string;
  plaintext: string;
}

export const listAgents = () => api.get<AgentSummary[]>("/connected-agents");
export const createAgent = (name: string) => api.post<AgentSummary>("/connected-agents", { name });
export const generateAgentKey = (agentId: string) =>
  api.post<GeneratedKey>(`/connected-agents/${agentId}/keys`, {});
export const revokeAgentKey = (agentId: string, keyId: string) =>
  api.post<{ ok: boolean }>(`/connected-agents/${agentId}/keys/${keyId}/revoke`, {});
export const patchAgent = (agentId: string, body: { status?: "active" | "disabled"; name?: string }) =>
  api.patch<AgentSummary>(`/connected-agents/${agentId}`, body);
export const deleteAgent = (agentId: string) => api.delete<void>(`/connected-agents/${agentId}`);
